import { Navigate } from "react-router-dom"
import { useUser } from "reactfire"

export default function PrivateRoute({ children }) {
  const { data: user, status } = useUser()

  if (status === "loading") {
    return <div>Cargando...</div>
  }

  return user ? children : <Navigate to="/login" />
}
